// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2G-NM","errors":"Errors_errors__2om0D"};